import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {FabFilterDescriptor} from '@fabric/components/table-filter/data-query';
import {catchError, map, Observable, of} from 'rxjs';
import {environment} from '../../environments/environment';
import {OtdsError} from '../models/OtdsError';
import {OtdsFileLog} from '../models/OtdsFileLog';
import {PagedRequest} from '../models/PagedRequest';
import {PagedResponse} from '../models/PagedResponse';

@Injectable({
  providedIn: 'root'
})
export class OtdsErrorService {

  private readonly url = environment.otdsUrl;
  private readonly excelUrl = environment.excelUrl;

  constructor(private readonly httpClient: HttpClient) {
  }

  public getErrorsPage(
    page: number,
    pageSize: number,
    sortFields: string[],
    sortDirection: 'asc' | 'desc' | '',
    filters: FabFilterDescriptor[]
  ): Observable<PagedResponse<OtdsError>> {
    const req = new PagedRequest();
    req.page = page;
    req.pageSize = pageSize;
    req.sortFields = sortFields;
    req.sortDirection = sortDirection;
    req.filters = filters;

    return this.httpClient.post<PagedResponse<OtdsError>>(this.url + "/pagination_sorting_filtering", req)
    .pipe(
      map((a: PagedResponse<OtdsError>) => {
        a.data = a.data.map(e => OtdsError.transform(e));
        return a;
      })
    );
  }

  public reprocessOtdsErrors(ids: number[]): Observable<any> {
    return this.httpClient.post(this.url, ids);
  }

  public archiveOtdsErrors(ids: number[]): Observable<any> {
    return this.httpClient.post(this.url + '/archive', ids);
  }

  public getFileLogPage(
    page: number,
    pageSize: number,
    sortFields: string[],
    sortDirection: 'asc' | 'desc' | '',
    filters: FabFilterDescriptor[]
  ): Observable<PagedResponse<OtdsFileLog>> {

    const req = new PagedRequest();
    req.page = page;
    req.pageSize = pageSize;
    req.sortFields = sortFields;
    req.sortDirection = sortDirection;
    req.filters = filters;

    return this.httpClient.post<PagedResponse<OtdsFileLog>>(this.url + "/log", req);
  }

  public getRowData(id: number): Observable<string> {
    return this.httpClient.get<string>(`${this.url}/rowData/${id}`);
  }

  downloadExcel(): Observable<Blob>  {
    return this.httpClient.get(this.excelUrl + '/otdsError', {responseType: 'blob'}).pipe(catchError(this.parseErrorBlob));
  }
  parseErrorBlob(err: HttpErrorResponse): Observable<any> {
    const reader: FileReader = new FileReader();
    let jsonError="";
    const obs = new Observable((observer: any) => {
      reader.onloadend = (e) => {
        console.log(JSON.parse((<any>e.target).result));
        observer.error(JSON.parse((<any>e.target).result));
        // alert("Error:\n" + (<any>e.target).result);
        observer.complete();
      }
    });
    reader.readAsText(err.error);
    return obs;
  }

}
